import { request } from "/src/utils/index.js";
import { request2 } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request2.get("sdcom/employee/list/page", { params });
}

export function Update(params) {
  return request.put("sdcom/employee", params);
}

export function Delete(data) {
  return request.delete("sdcom/employee", { data });
}
